import React, { useContext, useEffect, useState } from "react";
import "chartjs-adapter-date-fns";
import { RiRegisteredLine, RiMoneyDollarCircleLine, RiBankLine, RiFingerprintLine } from "react-icons/ri";
import { apiGet } from "utils/apiFetch";
import apiPath from "utils/apiPath";
import CountUp from "react-countup";
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";
import { Link } from "react-router-dom";
import useToastContext from 'hooks/useToastContext'

function AccountantHome() {
  const { t } = useTranslation();
  const notification = useToastContext()
  let { logoutUser, updatePageName, profileCompletion } = useContext(AuthContext);
  const [dashboardDetails, setDashboardDetails] = useState({});
  const getDashboardAccountantDetails = async () => {
    try {
      const payload = {};
      const path = apiPath.getDashboardAccountantDetails;
      const result = await apiGet(path, payload);
      setDashboardDetails({ ...dashboardDetails, ...result.data.results });
    } catch (error) {
      console.log("error:", error);
      if (error.response.status === 401 || error.response.status === 409) {
        logoutUser();
      }
    }
  };

  useEffect(() => {
    getDashboardAccountantDetails();
    // setTimeout(() => {notification.success(profileCompletion?.message)}, 10000)
  }, []);

  useEffect(() => {
    updatePageName(t("NAV_DASHBOARD"));
  }, []);

  return (
    <>
      <div className="py-4 px-4 md:px-8">
        <div className="sale_report grid 3xl:grid-cols-4 gap-4 2xl:grid-cols-3 sm:grid-cols-2 mb-7">
          <Link
            to="/all-employee-list"
            state={"accepted"}
            onClick={() => updatePageName(t("NAV_ALL_EMPLOYEE_LIST"))}
          >
            <div className="flex items-center sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 border">
              <h3 className="xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg">
                {dashboardDetails?.totalFinalEmp ? (
                  <>
                    <CountUp
                      duration={0.6}
                      end={dashboardDetails?.totalFinalEmp}
                    />
                  </>
                ) : (
                  0
                )}
                <span className="lg:ml-4 text-base font-normal block lg:inline-block text-gray-900">
                  {t("TOTAL_FINAL_EMPLOYEES")}
                </span>
              </h3>
              <span className="text-4xl ml-auto sm:mr-0 mt-2 sm:mt-0">
                <RiRegisteredLine />
              </span>
            </div>
          </Link>

          {/* Process Salary Link */}
          {/* <Link
            to="/payroll-wages"
            onClick={() => updatePageName(t("Process salary"))}
          >
            <div className="flex items-center sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 border">
              <h3 className="xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg">
                <span className="text-base font-normal block lg:inline-block text-gray-900">
                  {t("Process Payroll")}
                </span>
              </h3>
              <span className="text-4xl ml-auto sm:mr-0 mt-2 sm:mt-0">
                <RiBankLine />
              </span>
            </div>
          </Link> */}

          {/* Biometric Track Module Link */}
          <Link
            to="/attendance-report"
            onClick={() => updatePageName(t("BIOMETRIC_TRACK_MODULE"))}
          >
            <div className="flex items-center sm:text-left px-3 md:px-4 xl:px-6 lg:px-5 rounded-lg md:py-5 py-4 border">
              <h3 className="xl:flex block items-center mb-0 text-slate-900 font-bold md:text-2xl sm:text-lg text-lg">
                <span className="text-base font-normal block lg:inline-block text-gray-900">
                  {t("Employee Attendance")}
                </span>
              </h3>
              <span className="text-4xl ml-auto sm:mr-0 mt-2 sm:mt-0">
                <RiFingerprintLine />
              </span>
            </div>
          </Link>
        </div>
      </div>
    </>
  );
}

export default AccountantHome;